import { IconsSize, IconsStyle } from '../../enums';

const IconEnteComponent = ({
  size,
  style,
  color,
}: {
  size: IconsSize;
  style: IconsStyle;
  color: string;
}) => {
  return style === IconsStyle.OUTLINE ? (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1746_38370)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.66 2.03056C11.4427 2.06844 11.277 2.12498 10.828 2.31437C7.86798 3.56302 5.40196 5.02655 3.49369 6.66722C2.79515 7.2678 2.23655 7.82591 2.12916 8.03059C1.77439 8.70674 2.18259 9.51294 2.96124 9.67397C3.06876 9.69622 3.34943 9.70347 4.12442 9.70405L5.14587 9.70481V13.1137V16.5225L4.984 16.5469C4.46892 16.6246 3.92689 16.8702 3.50735 17.216C2.97631 17.6538 2.52662 18.3817 2.28005 19.2025C2.13146 19.6971 2.09933 19.8818 2.09877 20.2444C2.09828 20.5767 2.10076 20.5956 2.16826 20.7776C2.40057 21.4038 2.98423 21.8685 3.67375 21.9764C3.87454 22.0079 20.1259 22.0079 20.3267 21.9764C20.8818 21.8896 21.3945 21.5541 21.687 21.0864C21.7284 21.0203 21.7937 20.8813 21.8322 20.7776C21.8996 20.5956 21.9021 20.5767 21.9016 20.2444C21.9011 19.8818 21.8689 19.6971 21.7204 19.2025C21.4742 18.3832 21.0231 17.653 20.4931 17.216C20.0735 16.8702 19.5315 16.6246 19.0164 16.5469L18.8545 16.5225V13.1137V9.70481L19.876 9.70405C21.0158 9.70321 21.0686 9.6982 21.3498 9.56419C21.6565 9.41801 21.9019 9.11366 21.9809 8.78152C22.0191 8.62096 21.9977 8.32613 21.9366 8.171C21.8559 7.96593 21.7298 7.81045 21.3269 7.41897C19.3121 5.46163 16.5842 3.754 13.1724 2.31441C12.7119 2.12013 12.5601 2.06917 12.3225 2.02923C12.0884 1.98985 11.8912 1.99023 11.66 2.03056ZM11.7701 2.92312C11.5471 2.97732 10.3015 3.52321 9.4065 3.95902C7.38581 4.94301 5.65758 6.04008 4.21931 7.25184C3.85735 7.55679 3.00926 8.3606 2.96697 8.43876C2.91368 8.53729 2.9275 8.62042 3.01194 8.7093L3.08837 8.78972H12.0002H20.912L20.9885 8.7093C21.073 8.62029 21.0868 8.53697 21.0331 8.43876C20.9976 8.37387 20.2265 7.63396 19.9151 7.36594C18.7322 6.34813 17.3002 5.38423 15.6481 4.49384C15.0548 4.17414 13.7908 3.56756 13.1225 3.28186C12.2958 2.92849 12.2644 2.91761 12.0449 2.9095C11.9405 2.90564 11.8168 2.91178 11.7701 2.92312ZM6.0836 13.096V16.4872H8.80747H11.5313V13.096V9.70481H8.80747H6.0836V13.096ZM12.4691 13.096V16.4872H15.1929H17.9168V13.096V9.70481H15.1929H12.4691V13.096ZM5.26867 17.4161C4.94417 17.4559 4.55399 17.5948 4.30768 17.7582C3.91671 18.0176 3.56837 18.4697 3.33706 19.0179C3.15566 19.4479 2.98863 20.13 3.01498 20.3333C3.05014 20.6048 3.25765 20.8606 3.55951 21.0047L3.7258 21.0842H12.0002H20.2746L20.4409 21.0047C20.6554 20.9023 20.8279 20.7403 20.9163 20.5581C21.005 20.3755 21.0064 20.193 20.9219 19.8353C20.5705 18.349 19.8213 17.5372 18.6871 17.4137C18.4331 17.3861 5.49502 17.3884 5.26867 17.4161Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1746_38370">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1313 2.16931C11.687 1.94356 12.313 1.94356 12.8687 2.16931C16.0769 3.47247 19.2848 5.303 21.5893 7.68649C22.5418 8.67147 21.6988 10.08 20.4764 10.08H19.3206V16.2129C19.9087 16.4014 20.3988 16.7363 20.7887 17.178C21.3882 17.8569 21.7173 18.7468 21.8802 19.6425C22.1275 21.0028 20.9322 22 19.7059 22H4.29405C3.06766 22 1.87244 21.0028 2.11977 19.6425C2.28266 18.7468 2.61168 17.8569 3.21119 17.178C3.60117 16.7363 4.09129 16.4014 4.67938 16.2128V10.08H3.52352C2.30128 10.08 1.45824 8.67147 2.41062 7.68649C4.71518 5.303 7.92306 3.47247 11.1313 2.16931ZM17.0088 16.04V10.08H13.1559V16.04H17.0088ZM6.99114 10.08H10.8441V16.04H6.99114V10.08Z"
        fill={color}
      />
    </svg>
  );
};

export default IconEnteComponent;
